export const isShallowDifferent = (arrayA: unknown[], arrayB: unknown[]) =>
	arrayA.length !== arrayB.length ||
	arrayA.some((currentElement, index) => currentElement !== arrayB[index]);
